export const serverURL = 'https://lucas-alonso-social-media.herokuapp.com/graphql';
// export const serverURL = 'http://localhost:7000/graphql';